<template>
	<pageWithNav>
		<innerPage :innerTopNav="true">
			<div slot="page">
				<div style="display: flex; flex-direction: row">
					<div>
						<h1>Templates</h1>
						<h3 style="font-weight: bold; margin-bottom: 0px">
							Create instant workflows from a selection of ready made templates
						</h3>
					</div>

					<div style="display: flex; margin-left: auto; align-items: flex-end">
						<el-pagination :pager-count="5" :page-sizes="[10, 20, 50]" @current-change="returnAllTemplates"
							@size-change="returnAllTemplates" background :page-size.sync="pageSize"
							layout="sizes, prev, pager, next" :total="totalRecords" :current-page.sync="currentPage" />
					</div>
				</div>

				<el-divider class="compressedDivider"></el-divider>

				<el-container>
					<el-aside style="width: 250px">

						<el-input clearable placeholder="Search for keyword" prefix-icon="el-icon-search"
							v-model="templateSearchQuery" style="margin-bottom: 20px; width: 95%; margin-top: 24px" />

						<sideList :multiSelect="true" @event="ownershipFiltersEvent"
							:options="ownershipFilterOptions" />

						<el-divider></el-divider>

						<h4 style="margin-bottom:6px">Industry</h4>
						<el-select v-model="selectedIndustries" multiple filterable collapse-tags
							:filter-method="filterIndustries" @visible-change="initIndustries"
							style="width:95%;">
							<el-option v-for="i in visibleIndustries" :key="i" :label="i" :value="i" />
						</el-select>

						<h4 style="margin-bottom:6px">Department</h4>
						<el-select v-model="selectedDepartments" multiple filterable collapse-tags
							:filter-method="filterDepartments" @visible-change="initDepartments"
							style="width:95%;">
							<el-option v-for="d in visibleDepartments" :key="d" :label="d" :value="d" />
						</el-select>

						<h4 style="margin-bottom:6px">Tags</h4>
						<el-select v-model="selectedTags" multiple filterable collapse-tags :filter-method="filterTags"
							@visible-change="initTags" style="width:95%">
							<el-option v-for="t in visibleTags" :key="t" :label="t" :value="t" />
						</el-select>

					</el-aside>

					<el-container>
						<el-main style="padding: 0px; overflow: hidden">
							<templateItemList @itemRemoved="templateUnpublished" :filter="filters"
								:ownershipFilter="ownershipFilters" :list="availableTemplates"
								:searchQuery="templateSearchQuery" />
						</el-main>
					</el-container>
				</el-container>
			</div>
		</innerPage>
	</pageWithNav>
</template>

<script>
import pageWithNav from "../components/pageWithNav.vue";
import innerPage from "../components/innerPage.vue";
import sideList from "../components/sideList.vue";
import templateItemList from "../components/templateItemList.vue";

export default {
	components: { pageWithNav, innerPage, sideList, templateItemList },

	data() {
		return {
			pageSize: 10,
			totalRecords: 0,
			currentPage: 1,
			templateSearchQuery: "",
			availableTemplates: [],
			filters: [],
			ownershipFilters: [],

			selectedDepartments: [],
			selectedIndustries: [],
			selectedTags: [],

			allDepartments: [],
			allIndustries: [],
			allTags: [],

			visibleDepartments: [],
			visibleIndustries: [],
			visibleTags: [],

			ownershipFilterOptions: [
				{ name: "My Organisation", checked: false },
				{ name: "Publicly Available", checked: false },
				{ name: "Published By Me", checked: false },
			],
		};
	},
	created() {
		this.debouncedFetch = this.debounce(() => {
			this.returnAllTemplates()
		}, 300)
	},
	watch: {
		selectedDepartments() {
			this.currentPage = 1
			this.returnAllTemplates()
		},
		selectedIndustries() {
			this.currentPage = 1
			this.returnAllTemplates()
		},
		selectedTags() {
			this.currentPage = 1
			this.returnAllTemplates()
		},
		templateSearchQuery() {
			this.currentPage = 1
			this.debouncedFetch()
		},
		ownershipFilters() {
			this.currentPage = 1
			this.returnAllTemplates()
		}
	},

	async mounted() {
		this.returnAllTemplates();
		this.fetchTemplateFilters();
	},

	methods: {
		debounce(fn, delay) {
			let t
			return (...args) => {
				clearTimeout(t)
				t = setTimeout(() => fn.apply(this, args), delay)
			}
		},
		initDepartments(open) {
			if (open) this.visibleDepartments = this.allDepartments.slice(0, 15);
		},

		initIndustries(open) {
			if (open) this.visibleIndustries = this.allIndustries.slice(0, 15);
		},

		initTags(open) {
			if (open) this.visibleTags = this.allTags.slice(0, 15);
		},

		filterDepartments(q) {
			if (!q) return this.initDepartments(true);
			this.visibleDepartments = this.allDepartments
				.filter(v => v.toLowerCase().includes(q.toLowerCase()))
				.slice(0, 50);
		},

		filterIndustries(q) {
			if (!q) return this.initIndustries(true);
			this.visibleIndustries = this.allIndustries
				.filter(v => v.toLowerCase().includes(q.toLowerCase()))
				.slice(0, 50);
		},

		filterTags(q) {
			if (!q) return this.initTags(true);
			this.visibleTags = this.allTags
				.filter(v => v.toLowerCase().includes(q.toLowerCase()))
				.slice(0, 50);
		},

		async returnAllTemplates() {
			const result = await this.httpHelper(
				"RUNTIME",
				"POST",
				`template/returnTemplatesSummary?resultsPerPage=${this.pageSize}&page=${this.currentPage - 1}`,
				{
					searchTags: this.selectedTags,
					departments: this.selectedDepartments,
					industries: this.selectedIndustries,
					page: this.currentPage - 1,
					resultsPerPage: this.pageSize,
					searchQuery: this.templateSearchQuery,
					ownershipFilters: this.ownershipFilters,
				}
			);

			if (!result?.error) {
				this.availableTemplates = result.response.templates;
				this.totalRecords = result.response.totalRecords;
			} else {
				this.$notifyError(this, result.error);
			}
		},

		async fetchTemplateFilters() {
			const result = await this.httpHelper("RUNTIME", "GET", "template/returnTemplateFilters", {});

			if (!result?.error) {
				const d = result.response || {};
				this.allDepartments = (d.departments || []).sort();
				this.allIndustries = (d.industries || []).sort();
				this.allTags = (d.tags || []).sort();
			}
		},

		templateUnpublished(id) {
			this.availableTemplates = this.availableTemplates.filter(t => t.publishedWorkflowId !== id);
		},

		sideListEvent(f) {
			this.filters = f;
		},

		ownershipFiltersEvent(f) {
			this.ownershipFilters = f;
		}
	},
};
</script>

<style scoped>
.compressedDivider {
	margin-bottom: 0px;
}
</style>
